import React, { Component } from 'react';
import L from 'leaflet';

const rotatingArrow = L.icon({
	iconUrl: 'https://i.imgur.com/D0pBBzL.gif',
	iconSize: [35, 37],
	iconAnchor: [19, 19],
	popupAnchor: [0, 0]
});

class Map extends Component {
	state = {
		imageSize: [9967, 5820]
	};

	componentDidMount() {
		this.map = L.map('mapContainer', {
			zoomControl: false,
			attributionControl: false
		});
		this.rc = new L.RasterCoords(this.map, this.state.imageSize);
		this.marker = L.marker([-500, -500], { icon: rotatingArrow });
		this.map.setMinZoom(4);
		this.map.setMaxZoom(this.rc.zoomLevel() + 1);
		this.map.setView(this.rc.unproject([4948, 2491]), 5);
		this.surfaceLayer = L.tileLayer(`/tiles/{z}/{x}/{y}.png`, {
			edgeBufferTiles: 2,
			noWrap: true
		}).addTo(this.map);
		this.isMarker = false;

		this.map.on('click', event => this.handleClick(event));
	}

	// The function that runs whenever the map is clicked
	handleClick = event => {
		// Get the coordinates of where they clicked
		const coords = this.rc.project(event.latlng);

		// Set this.markedLocation equal to where they clicked
		this.markedLocation = this.rc.unproject([Math.floor(coords.x), Math.floor(coords.y)]);

		// Add Spinning Arrow to Map
		// If theres no marker at all, add one
		if (!this.isMarker) this.marker.addTo(this.map);

		// Set the marker location to where they clicked
		this.marker.setLatLng(this.markedLocation);
	};

	render() {
		return <div id="mapContainer" />;
	}
}

export default Map;
